import { Container } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWindowSize } from '../hooks';

import { useAuth } from '../redux/slices/auth';

import { Header } from './Header';
import type { SxProps, Theme } from '@mui/material';

export interface AppContainerProps {
	sx?: SxProps<Theme>;
	children: React.ReactNode;
}

export const AppContainer = ({ sx, children }: AppContainerProps): JSX.Element => {
	const location = useLocation();
	const navigate = useNavigate();

	const windowSize = useWindowSize();

	const { isLoggingIn, isLoggedIn } = useAuth();

	const [appBarHeight, setAppBarHeight] = useState(0);

	const appBarRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isLoggingIn) {
			return;
		}

		if (isLoggedIn) {
			if (location.pathname.startsWith('/login') || location.pathname.startsWith('/sso')) {
				navigate('/');
			}
		} else {
			navigate('/login');
		}
	}, [location.pathname, isLoggingIn, isLoggedIn]);

	useEffect(() => {
		window.setTimeout(() => {
			if (appBarRef.current) {
				setAppBarHeight(appBarRef.current.getBoundingClientRect().height);
			}
		}, 0);
	}, [windowSize, appBarRef.current]);

	return (
		<>
			<Header ref={appBarRef} />
			<Container
				maxWidth={false}
				sx={{
					maxHeight: `calc(100vh - ${appBarHeight}px)`,
					overflow: 'auto',
					...(sx ?? {}),
				}}
			>
				{(isLoggedIn ||
					location.pathname.startsWith('/login') ||
					location.pathname.startsWith('/sso')) &&
					children}
			</Container>
		</>
	);
};
